import React from "react";

export default function ShopIcon({ size = 50, color = "#ffffff", style = {} }) {

	return <span className="imgIcon" style={{
		height: size,
		width: size,
		...style
	}}>
		<svg version="1.1" id="Layer_1" x="0px" y="0px"
			viewBox="0 0 28 28" >
			<path id="Path_20" style={{ fill: color }} d="M25.2,10.5L23,7.6c0,0,0-0.1-0.1-0.1c0,0,0-0.1-0.1-0.1l-0.1-0.1l-0.1-0.1V3.8
	c0-0.2,0-0.4-0.1-0.6c-0.1-0.2-0.2-0.3-0.3-0.5c-0.1-0.1-0.3-0.2-0.5-0.3c-0.2-0.1-0.4-0.1-0.6-0.1H6.7c-0.2,0-0.4,0-0.6,0.1
	C6,2.5,5.8,2.6,5.7,2.8C5.6,2.9,5.5,3,5.4,3.2C5.3,3.4,5.3,3.6,5.3,3.8v3.5L5.2,7.3L5.1,7.4c0,0,0,0.1-0.1,0.1c0,0,0,0.1-0.1,0.1
	l-2.2,2.9c-0.1,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.1,0.2-0.1,0.3c0,0.1-0.1,0.2-0.1,0.3c0,0.1,0,0.2,0,0.4v0.7c0,0.3,0.1,0.6,0.2,0.9
	c0.1,0.3,0.3,0.5,0.5,0.7c0.2,0.2,0.4,0.4,0.7,0.5c0.3,0.1,0.6,0.2,0.9,0.2v9.5c0,0.2,0,0.4,0.1,0.6C4.7,25,4.8,25.1,5,25.2
	c0.1,0.1,0.3,0.2,0.5,0.3c0.2,0.1,0.4,0.1,0.6,0.1H22c0.2,0,0.4,0,0.6-0.1c0.3-0.1,0.6-0.4,0.8-0.8c0.1-0.2,0.1-0.4,0.1-0.6v-9.5
	c0.3,0,0.6-0.1,0.9-0.2c0.3-0.1,0.5-0.3,0.7-0.5c0.2-0.2,0.4-0.4,0.5-0.7c0.1-0.3,0.2-0.6,0.2-0.8v-0.7c0-0.1,0-0.2,0-0.4
	c0-0.1-0.1-0.2-0.1-0.3c0-0.1-0.1-0.2-0.1-0.3C25.3,10.7,25.3,10.6,25.2,10.5z M21.3,3.8v2.9H6.7V3.8H21.3z M9.7,13.3H6.7l2.9-5.1
	h1.6L9.7,13.3z M11.9,8.2h1.7v5.1h-3.1L11.9,8.2z M14.3,8.2H16l1.5,5.1h-3.1V8.2z M16.7,8.2h1.6l2.9,5.1h-3.1L16.7,8.2z M3.7,12.6
	v-0.7c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1l0-0.1c0,0,0-0.1,0.1-0.1l2.2-2.9c0,0,0.1-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1c0,0,0.1,0,0.2-0.1
	c0.1,0,0.1,0,0.2,0h2.1l-2.9,5.1H4.5c-0.1,0-0.2,0-0.3-0.1C4.1,13.2,4,13.1,4,13c-0.1-0.1-0.1-0.2-0.2-0.2
	C3.8,12.7,3.7,12.6,3.7,12.6L3.7,12.6z M16.9,24.2h-5.5v-7.3h5.5V24.2z M22,24.2h-4.4v-7.3c0-0.1,0-0.2-0.1-0.3
	c0-0.1-0.1-0.2-0.2-0.2c-0.1-0.1-0.2-0.1-0.2-0.2c-0.1,0-0.2-0.1-0.3-0.1h-5.5c-0.1,0-0.2,0-0.3,0.1c-0.1,0-0.2,0.1-0.2,0.2
	c-0.1,0.1-0.1,0.2-0.2,0.2c0,0.1-0.1,0.2-0.1,0.3v7.3H5.9v-9.5h16.1L22,24.2L22,24.2z M24.1,12.5c0,0.1,0,0.2-0.1,0.3
	c0,0.1-0.1,0.2-0.2,0.2c-0.1,0.1-0.2,0.1-0.2,0.2c-0.1,0-0.2,0.1-0.3,0.1H22l-2.9-5.1h2.1c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0.1
	c0.1,0,0.1,0.1,0.1,0.1c0,0,0.1,0.1,0.1,0.1l2.2,2.9c0,0,0.1,0.1,0.1,0.1l0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1L24.1,12.5
	L24.1,12.5z"/>
		</svg>
	</span >
}